import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";

const useStyles = makeStyles({
  rootBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "auto",
    background: "#E9ECF7",
    border: "2px solid #CACCD1",
    fontWeight: 600,
    marginBottom: "10px",
    paddingTop: "16px",
    paddingBottom: "16px"
  },
  titleBox: {
    width: "160px",
    display: "block",
    textAlign: "center"
  },
  chipTitle: {
    backgroundColor: "#D0101B"
  },
  chipSubtitle: {
    backgroundColor: "rgba(48,73,103,0.8)",
    marginTop: "16px"
  }
});

export default function TitleBox({ title, subtitle, iconTitle, iconSubtitle }) {
  const classes = useStyles();
  return (
    <div className={classes.rootBox}>
      <div className={classes.titleBox}>
        <Chip
          color="primary"
          className={classes.chipTitle}
          label={title}
          icon={iconTitle}
        />
        <Chip
          color="primary"
          className={classes.chipSubtitle}
          size="small"
          icon={iconSubtitle}
          label={subtitle}
        />
      </div>
    </div>
  );
};
